import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-2.webp";
import diverseImage from "../images/comp/diverse-friends-using-digital-devices 3.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import developmentIcon from "../images/development.png";
import qualityIcon from "../images/Quality.png";
import testingIcon from "../images/Testing.png";

const WebdevelopmentPage = () => {
  const heroBannerData = {
    subtitle: "Web Development",
    title: "Websites That Engage. Websites That Convert.",
    description:
      "At Hope Web Solutions, we build high-performing, scalable websites tailored to your business goals. Whether you're launching a startup or modernizing an enterprise platform, our expert developers create fast, secure, and user-friendly websites that drive results. We focus on clean code, responsive design, and seamless user experience across all devices.",
    buttonText: "Contact now",
    buttonLink: "#contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Custom Website Development",
      description:
        "Tailor-made websites built from scratch to meet your specific business requirements and branding.",
      icon: researchIcon,
    },
    {
      title: "Responsive Web Design",
      description:
        "Mobile-first, cross-device compatible design that delivers an optimal viewing experience on any screen.",
      icon: planningIcon,
    },
    {
      title: "E-commerce Development",
      description:
        "Building secure and user-friendly online stores with integrated payment gateways, inventory management, and order tracking.",
      icon: designIcon,
    },
    {
      title: "CMS Development",
      description:
        "Developing dynamic and easy-to-manage websites using WordPress, Joomla, Drupal, and other content management systems.",
      icon: developmentIcon,
    },
    {
      title: "Web App Development",
      description:
        "Creating fast, scalable, and feature-rich web applications for desktop and mobile browsers.",
      icon: testingIcon,
    },
    {
      title: "API Integration",
      description:
        "Seamless integration of third-party APIs for payment gateways, CRMs, analytics, and more.",
      icon: qualityIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Analysis",
      description:
        "Understanding your business needs, target audience, and goals to define the website’s scope.",
      icon: researchIcon,
    },
    {
      title: "Wireframing & Planning",
      description:
        "Laying out the website structure, sitemap, and user flow for a clear development path.",
      icon: designIcon,
    },
    {
      title: "Design Phase",
      description:
        "Creating visually engaging and brand-aligned UI designs for web interfaces.",
      icon: developmentIcon,
    },
    {
      title: "Development Phase",
      description:
        "Coding the front-end and back-end of the website using best practices and modern technologies.",
      icon: testingIcon,
    },
    {
      title: "Testing & QA",
      description:
        "Performing rigorous testing for performance, security, and cross-browser compatibility.",
      icon: qualityIcon,
    },
    {
      title: "Launch & Support",
      description:
        "Deploying the website and offering ongoing maintenance, updates, and performance optimization.",
      icon: planningIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Web Solutions?",
    image: diverseImage,
    imageAlt: "Team",
    items: [
      {
        label: "Planning",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };

  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="process-grid mt-0">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="Web Development Process"
        subtitle="Our structured development process ensures high-quality, secure, and scalable web solutions delivered on time."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default WebdevelopmentPage;
